/** The search of `/sheets/$docId` (1.AC-2 deliverable 3): `sheet` (a uuid) and `compare` (`1`). */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface SheetFormSearch {
  readonly sheet?: string;
  readonly compare?: 1;
}

/** Keeps what is valid and drops anything else, without throwing. */
export function validateSheetSearch(search: Record<string, unknown>): SheetFormSearch {
  const sheet =
    typeof search.sheet === 'string' && UUID.test(search.sheet) ? search.sheet : undefined;
  const compare = search.compare === 1 || search.compare === '1' ? (1 as const) : undefined;
  return {
    ...(sheet === undefined ? {} : { sheet }),
    ...(compare === undefined ? {} : { compare }),
  };
}
